<template>
    <div class="step">
        <div class="step-header d-none d-md-block">
            <div class="svg-icon" :style="'mask: url(/img/icons/folder.svg); -webkit-mask-image: url(/img/icons/folder.svg);'"></div>
            {{ $t('titles.more') }}
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group row align-items-center" v-if="this.type !== 'land'">
                    <label for="rating" class="required font-weight-medium col-lg-6">{{ $t('parameters.form.names.rating') }}</label>
                    <div class="col-lg-6">
                        <select id="rating" name="rating" class="custom-select w-100" v-model="rating" required>
                            <option v-for="option in options" :value="option.value">
                                {{ $t('parameters.form.rating.' + option.value) }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group row align-items-center" v-else>
                    <label for="rating" class="required font-weight-medium col-lg-6">{{ $t('parameters.form.names.land_type') }}</label>
                    <input id="rating" name="rating" value="good" type="hidden" required>
                    <div class="col-lg-6">
                        <select id="land_type" name="land_type" class="custom-select" v-model="landType" required>
                            <option v-for="option in optionsLand" :value="option.value">
                                {{ $t('parameters.form.land_type.' + option.value) }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="col-md-6 step__help" v-show="this.type !== 'land' && !(this.rating === null || this.rating === undefined)">
                <div class="help">
                    <div class="text">
                        <b class="d-block">{{ $t('parameters.form.rating.' + this.rating) }}</b>
                        {{ $t('parameters.form.rating.help.' + type + '.' + rating) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Condition",

        props: ['assetsUrl'],

        data: function() {
            return {
                rating: 'good',
                landType: null,

                header: {
                    bad: 'Neobyvatelný',
                    nothing_much: 'Před rekonstrukcí',
                    good: 'Průměrný',
                    very_good: 'Velmi dobrý',
                    new: 'Novostavba',
                    excellent: 'Luxusní'
                },

                options: [
                    {value: 'bad', text: 'Neobyvatelný'},
                    {value: 'nothing_much', text: 'Před rekonstrukcí'},
                    {value: 'good', text: 'Průměrný'},
                    {value: 'very_good', text: 'Velmi dobrý'},
                    {value: 'new', text: 'Novostavba'},
                    {value: 'excellent', text: 'Luxusní'},
                ],

                optionsLand: [
                    {value: null, text: 'Neuvedeno'},
                    {value: 'building', text: 'Stavební'},
                    {value: 'field', text: 'Pole'},
                    {value: 'garden', text: 'Zahrada'},
                    {value: 'meadow', text: 'Louka'},
                    {value: 'forest', text: 'Les'},
                    {value: 'other', text: 'Jiný'},
                ],

                help: {
                    flat: {
                        bad: 'Byt, ve kterém bez kompletní rekonstrukce není možné bydlet. Chybí koupelna i kuchyň.',
                        nothing_much: 'Je zde možné bydlet, ale koupelna i kuchyň jsou min. 25 let staré a zasloužily by si modernizaci. Jedná se např. o panelové byty s umakartovým jádrem.',
                        good: 'Kuchyň i koupelna jsou ve stavu, že je možné je bez větších úprav plně využívat. Nejsou však po kompletní rekonstrukci v posledních letech.',
                        very_good: 'Byt je po kompletní rekonstrukci (kuchyň, koupelna, okna).',
                        new: 'Běžná novostavba nebo téměř nová nemovitost. Cena by měla být podobná ostatním novostavbám v okolí.',
                        excellent: 'Jsou použity velmi drahé technologie a materiály. Cena by měla být mnohem vyšší než u běžných novostaveb v okolí.'
                    },

                    house: {
                        bad: 'Dům je určený k demolici nebo kompletní rekonstrukci (střecha, okna, fasáda, kuchyň, koupelna).',
                        nothing_much: 'Nejméně 25 let zde neproběhla žádná rekonstrukce. Modernizaci si zaslouží interiér i exteriér.',
                        good: 'Dům lze pohodlně využívat. Interiér nebo exteriér však v posledních letech neprošel žádnou rekonstrukcí.',
                        very_good: 'Dům je po kompletní rekonstrukci (střecha, okna, fasáda, kuchyň, koupelna).',
                        new: 'Běžná novostavba nebo téměř nová nemovitost. Cena by měla být podobná ostatním novostavbám v okolí.',
                        excellent: 'Jsou použity velmi drahé technologie a materiály. Cena by měla být mnohem vyšší než u běžných novostaveb v okolí.'
                    },

                    land: {
                        null: 'Neuvedeno',
                        building: 'Stavební',
                        field: 'Pole',
                        garden: 'Zahrada',
                        meadow: 'Louka',
                        forest: 'Les',
                        other: 'Jiný'
                    }
                },
            }
        },

        computed: {
            type: function () {
                let type = this.$parent.getType();
                if (type == "cottage" || type == "hut") {
                    type = "house";
                }

                return type;
            },

            required: function () {
                return true;
            },
        },

        mounted() {
            this.rating = this.$parent.oldData.rating;
            this.landType = this.$parent.oldData.land_type;
        }
    }
</script>

<style scoped>
    .help {
        max-width: 380px;
        color: #688389;
        font-size: 13px;
        margin: 0 auto;
        background-color: #ebf9fc;
        left: 0;
        top: 0;
        border-bottom: 2px solid #dfe8ea;
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 1.5rem;
    }

    @media (min-width: 767px) {
        .help {
            position: absolute;
            margin-bottom: 0;
        }

        .help:before {
            content: '';
            display: block;
            position: absolute;
            top: 15px;
            left: -10px;
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-bottom: 10px solid transparent;
            border-right: 10px solid #ebf9fc;
        }
    }

    .help img {
        display: inline-block;
        vertical-align: top;
        width: 20px;
        height: 20px;
        margin-right: 5px;
    }

    .help .text {
        display: inline-block;
        vertical-align: top;
        text-align: left;
        width: calc(100% - 5px);
    }
</style>
